import {Modal} from "react-bootstrap";
import {useState} from "react";
import block from "bem-css-modules";
import s from './Lecturer.module.scss';
import {useSelector} from "react-redux";
import {selectLecturers} from "../Reducers/ProgramReducer";

const b = block(s);

export const Lecturer = ({lecturer}) => {
    const [show, setShow] = useState(false);
    const lecturers = useSelector(selectLecturers)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const lecturerInfo = lecturers.find(item => item.id === lecturer.id) || lecturer;

    return (<>
        <span className={b('name')} onClick={handleShow}>{lecturerInfo.name}</span>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{lecturerInfo.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={'row'}>
                    <div className="col-12 col-md-4">
                    <img src={lecturer.image.url} className="img-fluid"
                         alt={lecturerInfo.name}/>
                    </div>
                    <div className={'col-12 col-md-8'}>
                        <h3>{lecturerInfo.country}</h3>
                        <h4>{lecturerInfo.occupation}</h4>
                        <div dangerouslySetInnerHTML={{__html: lecturerInfo.bio}}></div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </>)
}
